import { ErrorPanel, Footer, Header, Page } from '../_shared/ui'

export default function NotFound() {
  return (
    <Page>
      <Header />
      <ErrorPanel
        title="Page not found"
        body="The link you followed does not exist. Please check the link your sponsor sent."
      />
      <Footer />
    </Page>
  )
}
